export const Camera = () => {
  return (
    <svg viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 13.4444C17 13.857 16.8468 14.2527 16.574 14.5444C16.3012 14.8361 15.9312 15 15.5455 15H2.45455C2.06878 15 1.69881 14.8361 1.42603 14.5444C1.15325 14.2527 1 13.857 1 13.4444V4.55556C1 4.143 1.15325 3.74733 1.42603 3.45561C1.69881 3.16389 2.06878 3 2.45455 3H5L7 1H11L13 3H15.5455C15.9312 3 16.3012 3.16389 16.574 3.45561C16.8468 3.74733 17 4.143 17 4.55556V13.4444Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
